// Decimal pad input must stay as text while editing (e.g. "12," -> "12,5").
// Accept either local comma or decimal point; reject mixed/thousands notation.
export function nonnegativeDecimal(text){
 const value=String(text??'').trim();if(!value)return NaN;
 if(!/^(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(value))return NaN;
 const number=Number(value.replace(',','.'));return Number.isFinite(number)&&number>=0?number:NaN;
}
export function optionalNonnegativeDecimal(text){return String(text??'').trim()?nonnegativeDecimal(text):null;}
